import styles from "./PolicyLastUpdated.module.css";

interface PolicyLastUpdatedProps {
  date: string;
}

function formatDate(dateStr: string): string {
  const date = new Date(dateStr);
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

export default function PolicyLastUpdated({
  date,
}: PolicyLastUpdatedProps): JSX.Element {
  return (
    <div className={styles.container}>
      <div className={styles.text}>Last Updated: {formatDate(date)}</div>
    </div>
  );
}
